import axios, { AxiosResponse } from 'axios'

import { CustomerInterface, CustomerNoteInterface } from '../Interfaces/CustomerInterface'
import { getRequestConfig } from './index'

export async function getCustomers(pageable?: {
  page: number
  size: number
  searchTerm: string
}): Promise<AxiosResponse<any>> {
  // eslint-disable-next-line max-len
  const url = pageable
    ? `/platform/v4/customers?page=${pageable?.page}&size=${pageable?.size}&search=${pageable?.searchTerm}`
    : '/platform/v4/customers'
  const response = await axios.get(url, getRequestConfig())
  return response
}

export async function getCustomerById(id: number) {
  const url = `/platform/v4/customers/${id}`
  const response = await axios.get(url, getRequestConfig())
  return response.data as CustomerInterface
}

export async function getCustomerForSearchedText(searchText: string): Promise<CustomerInterface[]> {
  const response = await axios.get(`/platform/v4/customers?search=${searchText}`, getRequestConfig())
  return response.data
}

export async function createCustomer(customer: CustomerInterface): Promise<CustomerInterface> {
  const response = await axios.post('/platform/v4/customers', customer, getRequestConfig())
  return response.data
}

export async function updateCustomer(customer: CustomerInterface): Promise<CustomerInterface> {
  const response = await axios.put(`/platform/v4/customers/${customer.id}`, customer, getRequestConfig())
  return response.data
}

export async function deleteCustomer(id: number): Promise<number> {
  const response = await axios.delete(`/platform/v4/customers/${id}`, getRequestConfig())
  return response.data || id
}

export async function importCustomers(customers: CustomerInterface[]): Promise<CustomerInterface[]> {
  const response = await axios.post('/platform/v4/customers/import', customers, getRequestConfig())
  return response.data
}

export async function getCustomerNotes(customerId: number): Promise<CustomerNoteInterface[]> {
  const response = await axios.get(`/platform/v4/customers/${customerId}/comments`, getRequestConfig())
  return response.data
}

export async function addCustomerNote(
  customerId: number,
  customerNote: CustomerNoteInterface,
): Promise<CustomerNoteInterface> {
  const response = await axios.post(`/platform/v4/customers/${customerId}/comments`, customerNote, getRequestConfig())
  return response.data
}

export async function updateCustomerNote(
  customerId: number,
  customerNote: CustomerNoteInterface,
): Promise<CustomerNoteInterface> {
  const response = await axios.put(
    `/platform/v4/customers/${customerId}/comments/${customerNote.id}`,
    customerNote,
    getRequestConfig(),
  )
  return response.data
}

export async function deleteCustomerNote(customerId: number, noteId: number) {
  const response = await axios.delete(`/platform/v4/customers/${customerId}/comments/${noteId}`, getRequestConfig())
  return response.data || noteId
}
